export default {
	/**
	 * load raw content of single_moderator_chat dynamically and insert it into the given div
	 */
	singleModeratorChatListener(containerSelector) {
		const $container = $(containerSelector);
		$container.find("a.j-chat-link").one("show.bs.tab", ({ target }) => {
			const chatId = /** @type {string} */ ($(target).attr("data-chat-id"));
			$.ajax({
				url: `/chats/${chatId}/single_moderator`,
				dataType: "script",
				// @ts-expect-error
			}).complete(({ responseText }) => {
				const $chatContainer = $container.find(`[class*='chat-${chatId}-']`);
				$chatContainer.html(responseText);
				$chatContainer
					.find(
						`.ChatMessage[data-actor-id='${$container.attr("data-for-actor-id")}']`,
					)
					.addClass("new forced");
				pp.chat.initNewChat(chatId, $chatContainer, true);

				// Highlight Message elements
				$chatContainer.observe().on("insertNode", (event, el) => {
					if (el.textContent.trim().length === 0) {
						// for some reason bootstrap inserts empty text nodes (only in moderator's area)
						return;
					}
					if (
						$(el).attr("data-actor-id") == $container.attr("data-for-actor-id")
					) {
						$(el).addClass("new forced");
					}
				});
			});
		});
		$container.find("a.j-chat-link").on("show.bs.tab", ({ target }) => {
			const chatId = /** @type {string} */ ($(target).attr("data-chat-id"));
			const $chatContainer = $container.find(`[class*='chat-${chatId}-']`);
			pp.chat.initNewChat(chatId, $chatContainer, true);
		});
	},

	/**
	 * wrapper function to render an activity chart (or sth. else)
	 * will use the data given in the .data() attribute of the respective div to populate the chart
	 * @param {Object} divID the target div in which the plot will be rendered
	 */
	invokePlot(divID) {
		const $div = $(`#${divID}`);
		const phaseMarkerObjects = [];
		const plotSeries = [];
		const plotArr = [];
		const formatStr = $div.data("date-string");

		if (formatStr === undefined || formatStr == "") {
			console.warn("No date methods format string provided");
		}
		if (
			$div.length == 0 ||
			$div.data() === undefined ||
			Object.keys($div.data()).length == 1
		)
			return; // length will never be 0 because the phase data is always present

		$div.html(""); // empty div in case there was anything else before

		// compose line objects to visualize phases
		if ($div.data()["Phases"] !== undefined) {
			$.each($div.data()["Phases"], (index, elem) => {
				//pp.log(index, elem);
				phaseMarkerObjects.push({
					verticalLine: {
						name: elem["name"],
						// when setting x for date axis the date to work must be in miliseconds, as explained in https://groups.google.com/group/jqplot-users/browse_thread/thread/55dd926fd0c8d118/f2eb762ba50aa608
						x: elem["startDate"],
						lineWidth: 2,
						color: "rgba(128, 128, 255, 0.75)",
						shadow: false,
						showTooltip: true,
						tooltipFormatString: elem["name"],
					},
				});

				// check for last phase and add line at the end
				if (index == $div.data()["Phases"].length - 1) {
					phaseMarkerObjects.push({
						verticalLine: {
							name: elem["name"],
							x: elem["endDate"],
							lineWidth: 2,
							color: "rgba(128, 128, 255, 0.75)",
							shadow: false,
						},
					});
				}
			});
		}
		pp.log("BACKEND invokePlot -- div:", $div);

		// add up elements incrementally to make charts more comprehensible
		for (const key in $div.data()) {
			const dataArray = $div.data(key);
			if (
				key == "Phases" ||
				dataArray.length == 0 ||
				typeof dataArray != "object"
			)
				continue;
			// put the word and message count in their own yAxis so that they don't squish the other activities' propoertions
			if (
				["MessagesWordCount", "Messages", "TextTaskWordCount"].indexOf(key) !=
				-1
			) {
				plotSeries.push({
					label: key,
					yaxis: "y2axis",
				});
			} else {
				plotSeries.push({
					label: key,
					yaxis: "yaxis",
				});
			}
			const incrementaryValArray = [];
			let incrementalAmount = 0;
			for (const index in dataArray) {
				const item = dataArray[index];
				const date = item[0];
				const amount = item[1];
				incrementalAmount += amount;
				incrementaryValArray.push([date, incrementalAmount]);
			}
			plotArr.push(incrementaryValArray);
		}

		// pp.log("plotArray", plotArr, formatStr, plotSeries, phaseMarkerObjects);

		// @ts-expect-error
		$.jqplot(divID, plotArr, {
			seriesDefaults: {
				// @ts-expect-error
				renderer: $.jqplot.lineRenderer,
				showMarker: true,
				markerOptions: {
					show: true,
					size: 6,
				},
				rendererOptions: {
					smooth: true,
					fillToZero: true,
				},
			},
			grid: {
				background: "#f7f7f7",
				drawBorder: false,
				shadow: false,
				gridLineColor: "#ddd",
				gridLineWidth: 1,
			},
			series: plotSeries,
			legend: {
				show: false,
				location: "nw",
			},
			axes: {
				xaxis: {
					// @ts-expect-error
					renderer: $.jqplot.DateAxisRenderer,
					tickOptions: {
						formatString: formatStr,
						showLabel: true,
					},
					autoscale: true,
				},
				yaxis: {
					min: 0,
					autoscale: true,
				},
				y2axis: {
					min: 0,
					autoscale: true,
				},
			},
			highlighter: {
				show: true,
				sizeAdjust: 7.5,
				fadeTooltip: true,
				bringSeriesToFront: true,
			},
			cursor: {
				show: true,
				showTooltip: false,
				zoom: true,
				tooltipLocation: "sw",
			},
			canvasOverlay: {
				show: true,
				objects: phaseMarkerObjects,
			},
		});
	},

	/**
	 * Wrapper function to initialize the table sorter in the backend
	 */
	initTableSorter() {
		const initFunction = (index, tableEl) => {
			const $table = $(tableEl);
			if ($table.data("tablesorter") !== undefined) {
				return;
			}
			// Get Headers with class no-sort
			const theHeaders = {};
			$table.find("th.no-sort").each(function (i, el) {
				theHeaders[$(this).index()] = { sorter: false };
			});

			// @ts-expect-error
			$table.tablesorter({
				theme: "blue",
				headers: theHeaders,
			});
		};
		$(document).on("page:change", () => {
			$("table.tablesorter").each(initFunction);
		});
		// Init once now
		$("table.tablesorter").each(initFunction);
	},

	dragDrop: {
		init(draggableElSelector, droppableElSelector, dropSuccessFunction) {
			this.draggableStartPos = { x: 0, y: 0 };
			this.currentDropTarget = null;
			this.draggableElSelector = draggableElSelector;
			this.droppableElSelector = droppableElSelector;
			this.dropSuccessFunction = dropSuccessFunction;

			this.initDragStateClassListeners();
			this.initReturnToStartPosListeners();
			this.initDroppable();
			this.initDraggable();
		},

		initDragStateClassListeners() {
			const dragStart = ({ target }) => {
				$(target).addClass("draggable--dragging");
			};
			const dragEnd = ({ target }) => {
				$(target).removeClass("draggable--dragging");
			};
			// @ts-expect-error
			interact(this.draggableElSelector)
				.on("dragstart", dragStart)
				.on("dragend", dragEnd);
		},

		initReturnToStartPosListeners() {
			const dragStart = ({ target }) => {
				// @ts-expect-error
				const rect = interact.getElementRect(target);
				pp.backend.dragDrop.draggableStartPos.x = rect.left + rect.width / 2;
				pp.backend.dragDrop.draggableStartPos.y = rect.top + rect.height / 2;
			};
			const dragEnd = ({ target }) => {
				const $el = $(target);
				$el.removeAttr("style");
				$el.removeAttr("data-x");
				$el.removeAttr("data-y");
			};
			// @ts-expect-error
			interact(this.draggableElSelector)
				.on("dragstart", dragStart)
				.on("dragend", dragEnd);
		},

		dragMoveListener(event) {
			const target = event.target;
			// Keep the dragged position in the data-x/data-y attributes
			const x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
			const y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;

			// Translate the element
			target.style.webkitTransform =
				target.style.transform = `translate(${x}px, ${y}px)`;

			// Update the posiion attributes
			target.setAttribute("data-x", x);
			target.setAttribute("data-y", y);
		},

		initDroppable() {
			// @ts-expect-error
			interact(this.droppableElSelector).dropzone({
				// Require a 30% element overlap for a drop to be possible
				overlap: 0.3,

				ondropactivate({ target }) {
					// Add active dropzone feedback
					target.classList.add("drop-active");
				},
				ondragenter({ relatedTarget, target }) {
					const draggableElement = relatedTarget;
					const dropzoneElement = target;

					// feedback the possibility of a drop
					dropzoneElement.classList.add("drop-target");
					draggableElement.classList.add("can-drop");
					pp.backend.dragDrop.currentDropTarget = target;
				},
				ondragleave({ target, relatedTarget }) {
					// remove the drop feedback style
					target.classList.remove("drop-target");
					relatedTarget.classList.remove("can-drop");
					pp.backend.dragDrop.currentDropTarget = null;
				},
				ondrop({ relatedTarget, target }) {
					if (!pp.backend.dragDrop.currentDropTarget) {
						return;
					}
					const $dragged = $(relatedTarget);
					const $dropzone = $(target);
					pp.backend.dragDrop.dropSuccessFunction($dragged, $dropzone);
				},
				ondropdeactivate({ target }) {
					// remove active dropzone feedback
					target.classList.remove("drop-active");
					target.classList.remove("drop-target");
				},
			});
		},

		initDraggable() {
			// @ts-expect-error
			interact(this.draggableElSelector).draggable({
				autoScroll: true,
				listeners: {
					move: this.dragMoveListener,
				},
			});
		},

		removeListeners() {
			if (!this.draggableElSelector || !this.droppableElSelector) {
				console.error("no element selectors for `interact` provided");
			}
			// @ts-expect-error
			interact(this.draggableElSelector).unset();
			// @ts-expect-error
			interact(this.droppableElSelector).unset();
			this.draggableElSelector = null;
			this.droppableElSelector = null;
			this.dropSuccessFunction = null;
		},
	},

	initUserInvitationCarouselListeners() {
		// normalize dimensions of items
		$("div.j-user-invitation-carousel").each(function () {
			const thisCarouselsItemHeights = [];
			const thisCarouselsItemWidths = [];
			$(this)
				.find("div.item")
				.each(function () {
					thisCarouselsItemHeights.push($(this).height());
					thisCarouselsItemWidths.push($(this).width());
				});
			const tallest = Math.max.apply(null, thisCarouselsItemHeights);
			const widest = Math.max.apply(null, thisCarouselsItemWidths);
			$(this)
				.find("div.item")
				.each(function () {
					$(this)
						.css("height", tallest + "px")
						.css("width", widest + "px");
				});
		});

		// listen for button clicks
		$("div.j-user-invitation-carousel")
			.find("button")
			.on("click", function () {
				const $carouselContainer = $(this).closest(
					"div.j-user-invitation-carousel",
				);
				if ($(this).hasClass("j-show-invitation-form")) {
					// @ts-expect-error
					$carouselContainer.find("form")[0].reset();
					$carouselContainer.find("input[type=text]").val("");
					// @ts-expect-error
					$carouselContainer.carousel(1);
				} else if ($(this).hasClass("j-show-options-button")) {
					// @ts-expect-error
					$carouselContainer.carousel(3);
				} else if ($(this).hasClass("j-send-reminder-email")) {
					$(this).prop("disabled", true);
					$carouselContainer.find("form").trigger("submit.rails");
				}
			});
	},

	unionslaborWaitingRoom: {
		waitingActorsPerGameToken: {},

		init(gameToken, alreadyOnlineActorData) {
			this.waitingActorsPerGameToken[gameToken] = alreadyOnlineActorData;
			this.waitingActorsPerGameToken.observeChange(
				gameToken,
				(oldval, newval) => {
					// need to proxy this so that the Game Token can be passed in
					pp.backend.unionslaborWaitingRoom.maintainOnlineStatus(
						gameToken,
						oldval,
						newval,
					);
				},
			);

			PrivatePub.subscribe(
				`/game_tokens/${gameToken}/lobby`,
				(data, channel) => {
					if (!data) {
						return;
					}

					// if (!data.already_online_actor_id)
					// pp.log("incoming", data);
					if (data.newly_online_actor_id) {
						var hashCopy = Object.assign(
							{},
							pp.backend.unionslaborWaitingRoom.waitingActorsPerGameToken[
								gameToken
							],
						);
						hashCopy[data.newly_online_actor_id] = data.user_name;
						pp.backend.unionslaborWaitingRoom.waitingActorsPerGameToken[
							gameToken
						] = hashCopy;
					} else if (data.newly_offline_actor_id) {
						var hashCopy = Object.assign(
							{},
							pp.backend.unionslaborWaitingRoom.waitingActorsPerGameToken[
								gameToken
							],
						);
						delete hashCopy[data.newly_offline_actor_id];
						pp.backend.unionslaborWaitingRoom.waitingActorsPerGameToken[
							gameToken
						] = hashCopy;
					} else if (data.start_game == true) {
						const $gameStatsContainer = $(`#game-token-${gameToken}`);
						$gameStatsContainer
							.find("span.j-game-in-prep, span.j-game-running")
							.toggleClass("hidden");
						$gameStatsContainer
							.find("span.j-game-running")
							.children("span.j-time-span")
							.html(data.time_span);
						$gameStatsContainer
							.find("a.actorsBadgeList-logoutButton:not(.j-no-user)")
							.removeClass("hidden");
					}
					// ignore everything else for now
				},
			);
		},
		maintainOnlineStatus(gameToken, oldval, newval) {
			const $gameStatsContainer = $(`#game-token-${gameToken}`);
			const $gameInPrep = $gameStatsContainer.find("span.j-game-in-prep");
			const $gameNotStarted = $gameStatsContainer.find(
				"span.j-game-not-started",
			);

			// pp.log("maintainOnlineStatus", gameToken, oldval, newval);
			for (var index in Object.keys(oldval)) {
				var actorId = Object.keys(oldval)[index];
				// @ts-expect-error
				if (newval[actorId] !== undefined) continue;

				var $actorBadgeItem = $(`#j-actor-badge-item-${actorId}`);
				$actorBadgeItem.find("span.actorsBadgeList-userName").html("—");
				$actorBadgeItem
					.find("span.actorsBadgeList-userName")
					.siblings()
					.addClass("j-no-user hidden");
			}
			if (Object.keys(newval).length) {
				for (var index in Object.keys(newval)) {
					var actorId = Object.keys(newval)[index];
					// @ts-expect-error
					if (oldval[actorId] !== undefined) continue;

					var $actorBadgeItem = $(`#j-actor-badge-item-${actorId}`);
					$actorBadgeItem
						.find("span.actorsBadgeList-userName")
						// @ts-expect-error
						.html(newval[actorId]);
					$actorBadgeItem
						.find("span.actorsBadgeList-userName")
						.siblings()
						.removeClass("j-no-user hidden");
				}
				$gameInPrep.removeClass("hidden");
				$gameNotStarted.addClass("hidden");
			} else {
				$gameInPrep.addClass("hidden");
				$gameNotStarted.removeClass("hidden");
			}
		},
	},

	initStepableForm($form) {
		$form.find("input").each((idx, field) => {
			$(field)
				.on("element:validate:fail.ClientSideValidations", () => {
					$form
						.find(
							"a.button:visible:not(.button--secondary), input[type='submit']",
						)
						.prop("disabled", true)
						.addClass("disabled");
				})
				.on("element:validate:pass.ClientSideValidations", () => {
					$form
						.find(
							"a.button:visible:not(.button--secondary), input[type='submit']",
						)
						.prop("disabled", false)
						.removeClass("disabled");
				});
		});
		// Always prevent the default behavior, trigger the validations, then trigger the button's/input's behavior if there are no errors
		$form
			.find("a.button:not(.button--secondary), input[type='submit']")
			.on("click", function (event) {
				event.preventDefault();
				event.stopPropagation();
				$form
					.find("input:visible, .select2-hidden-accessible")
					.each(function () {
						// @ts-expect-error
						$(this)
							.trigger("change.ClientSideValidations")
							.trigger("focusout.ClientSideValidations")
							.trigger("change");
					});
				setTimeout(function () {
					if (
						!$form.find(".tab-pane.active").find(".Field-with-errors").length
					) {
						pp.global.handleRailsLink($(event.currentTarget));
					}
				}, 10);
				return false;
			});

		$form.find("input:visible").first().focus().select();
		$form.validate();

		$form.on("shown.bs.tab", function (e) {
			// @ts-expect-error
			$(this).find("input:visible").first().focus().select();
			$form.validate();
		});
	},

	initManagerGameTokenWizard(gameSeriesId, genericModName, genericModEmail) {
		const validators = {
			"game_token[preset_game_cloning_props][name]":
				pp.viewHelpers.clientSideValidatorsFor("game", "name"),
			"game_token[moderator_name]": pp.viewHelpers.clientSideValidatorsFor(
				"user",
				"name",
			),
			"game_token[tokens_count]": pp.viewHelpers.clientSideValidatorsFor(
				"game_token",
				"tokens_count",
			),
		};

		const gameTplCheckboxCallback = (event) => {
			const $formInModal = $(event.target).closest("form");
			// pp.log("gameTplCheckboxCallback", event, event.target.value);
			if (event.originalEvent) {
				// No `originalEvent` means that this was called from `gameTplLocaleCheckboxCallback`
				// Check/uncheck the locale checkboxes if present
				pp.log(
					"gameTplCheckboxCallback -- tpl locales",
					$(`input[name*='[locales]'][data-tpl-id='${event.target.value}']`),
				);
				const $localeCheckboxesForTpl = $(
					`input[name*='[locales]'][data-tpl-id='${event.target.value}']`,
				);
				$localeCheckboxesForTpl.prop("checked", event.target.checked);
			}

			// Validate that any Game tpl checkbox has been marked
			const checkedTplsCount = $(`#new-clone-step-3-gs-${gameSeriesId}`).find(
				"input[name*='[game_tpl_id]']:checked",
			).length;
			if (checkedTplsCount) {
				return;
			}
			setTimeout(function () {
				// @ts-expect-error
				$formInModal[0].ClientSideValidations.addError(
					$(".game_token_game_tpl_ids"),
					`${I18n.t("errors.messages.required")}`,
				);
				$(`#new-clone-step-3-gs-${gameSeriesId}`)
					.find("input[name*='[game_tpl_id]']:first")
					.trigger("element:validate:fail.ClientSideValidations");
			}, 0);
		};

		// game_token[game_tpl_ids_and_locales][0][game_tpl_id]

		const gameTplLocaleCheckboxCallback = (event) => {
			const $formInModal = $(event.target).closest("form");
			const gameTplId = $(event.target).data("tpl-id");
			const $gameTplCheckbox = $(
				`input[name*='[game_tpl_id]'][value='${gameTplId}']`,
			);
			const $checkedLocaleCheckboxesForGameTpl = $formInModal.find(
				`input[name*='[locales]'][data-tpl-id='${gameTplId}']:checked`,
			);
			// pp.log("gameTplLocaleCheckboxCallback", event, $gameTplCheckbox);
			$gameTplCheckbox.prop(
				"checked",
				$checkedLocaleCheckboxesForGameTpl.length != 0,
			);
			$gameTplCheckbox.trigger("change"); // Invoke above `gameTplCheckboxCallback` to validate
		};

		const modalShownCallback = (event) => {
			const $formInModal = $(event.target).find("form");

			// Init a client side only validation for preset_game_cloning_props
			Object.entries(validators).forEach(([inputName, validatorProps]) => {
				$formInModal.data("clientSideValidations").validators[inputName] =
					validatorProps;
			});

			$(`#new-clone-step-3-gs-${gameSeriesId}`)
				.find("input[name*='[game_tpl_id]']")
				.on("change", gameTplCheckboxCallback);
			$(`#new-clone-step-3-gs-${gameSeriesId}`)
				.find("input[name*='[locales]']")
				.on("change", gameTplLocaleCheckboxCallback);

			pp.users.initRegisterEmailObserver(
				$("input[name='game_token[moderator_email]']"),
				[
					"format_invalid",
					"domain_inexistant",
					"email_taken_by_different_role",
					"forbidden",
				],
				"moderator",
			);
			pp.users.initRegisterEmailObserver(
				$(
					"input[name^='game_token[waiting_co_moderators_in_lobby]'][type='email']",
				),
				[
					"format_invalid",
					"domain_inexistant",
					"email_taken_by_different_role",
					"forbidden",
				],
				"moderator",
			);

			pp.backend.initStepableForm($formInModal);

			if (genericModName !== undefined && genericModEmail !== undefined) {
				$formInModal
					.find(`input[name='toggleable_boolean_gs_${gameSeriesId}_user_type']`)
					.on("click", function () {
						let nameVal = "";
						let emailVal = "";

						// @ts-expect-error
						if (!this.checked) {
							// set the (now hidden) fields to hold the default generic_mod name/email
							nameVal = genericModName;
							emailVal = genericModEmail;
						}
						$formInModal.find("#game_token_moderator_name").val(nameVal);
						$formInModal.find("#game_token_moderator_email").val(emailVal);

						$(`#new-clone-step-2-gs-${gameSeriesId}`)
							.find("input")
							.trigger("change.ClientSideValidations")
							.trigger("focusout.ClientSideValidations");
						setTimeout(function () {
							$formInModal.validate(); // Make ClientSideValidations observe the previously invisible input fields
						}, 20);
					});
			}

			$formInModal
				.find(
					`input[name='toggleable_boolean_gs_${gameSeriesId}_co_moderation']`,
				)
				.on("click", function () {
					var $emailValidationErrorMessages = $formInModal.find(
						".j-co-mod-fields .Field-with-errors input",
					);
					if ($emailValidationErrorMessages.length) {
						// Reset input fields so that no invalid data will be sent to Rails
						$formInModal
							.find(
								".j-co-mod-fields input[type='text'], .j-co-mod-fields input[type='email']",
							)
							.val("");
						// @ts-expect-error
						$formInModal[0].ClientSideValidations.removeError(
							$emailValidationErrorMessages,
						);
					}
				});
		};
		// Reset the form inputs
		const modalHiddenCallback = (event) => {
			// @ts-expect-error
			$(event.target).find("form")[0].reset();
			$(event.target).find(".tab-pane").removeClass("active");
			$(event.target).find(".tab-pane").first().addClass("active");
			$(event.target).find("[visible_contingent_on]").css({ display: "none" });
		};

		$(`#new-cloned-game-modal-gs-${gameSeriesId}`)
			.one("shown.bs.modal", modalShownCallback)
			.on("hidden.bs.modal", modalHiddenCallback);
	},

	initSortableRecordIndexListener() {
		// @ts-expect-error
		$(".RecordIndex--sortable").sortable({
			update(event, ui) {
				// @ts-expect-error
				let order = $(this).sortable("serialize");
				if ($(this).attr("data-sort-offset") !== undefined) {
					order += `&sort_offset=${$(this).attr("data-sort-offset")}`; // Add the URL param like a peasant
				}
				$.ajax({
					url: $(this).attr("data-sort-update-url"),
					type: "PUT",
					data: order,
				})
					.done((data) => {
						pp.notifications.display(
							"notice",
							I18n.t("cms.sorting.order_updated"),
						);
					})
					.fail((err) => {
						pp.notifications.display(
							"error",
							I18n.t("cms.sorting.error", { error_msgs: err.responseText }),
						);
					});
			},
		});
	},

	gameSwimlanes: {
		placeOutofBoundsHeaders(scrollEvent) {
			const $swimlanesContainer = $(scrollEvent.currentTarget);
			const currentScroll = $swimlanesContainer.scrollLeft();
			$swimlanesContainer
				.find(".GameSwimlanes__swimlane-content-wrapper")
				.each(function () {
					const $header = $(this).find(".GameSwimlanes__swimlane-header");
					const leftOffset = parseInt($(this).css("left"), 10);
					// @ts-expect-error
					if (leftOffset < currentScroll) {
						// @ts-expect-error
						$header.css("left", currentScroll - leftOffset);
					} else if (
						// @ts-expect-error
						currentScroll + $swimlanesContainer.width() <
						// @ts-expect-error
						leftOffset + $header.width()
					) {
						$header.css(
							"left",
							-(
								leftOffset +
								// @ts-expect-error
								$header.width() -
								// @ts-expect-error
								$swimlanesContainer.width() -
								// @ts-expect-error
								currentScroll
							),
						);
					} else {
						$header.css("left", 0);
					}
				});
		},

		init() {
			$(".GameSwimlanes")
				.off("scroll")
				.on(
					"scroll",
					_.debounce(pp.backend.gameSwimlanes.placeOutofBoundsHeaders, 15),
				);
			$(".GameSwimlanes").scrollLeft(
				parseInt($(".GameSwimlanes__now").css("left"), 10) -
					// @ts-expect-error
					$(".GameSwimlanes").width() / 2,
			);
			$(".GameSwimlanes")
				.find("a.GameSwimlanes__swimlane-toggle-link")
				.off("click")
				.on("click", function () {
					$(this)
						.closest(".GameSwimlanes__swimlane")
						.toggleClass("GameSwimlanes__swimlane--expanded");
				});
		},
	},

	handlePageChangeEvent() {
		// Exclude select boxes that are already initializes and the Actor template select boxes in the Game cloning form,
		const $selects = $(
			"select:visible:not(.select2-hidden-accessible):not(#game_actor_tpl_ids)",
		);

		// pp.log("init selects", $selects, $('select:visible:not(.select2-hidden-accessible)[size]'));
		pp.backend.initSortableRecordIndexListener();
		pp.backend.formHelpers.initSelect2For($selects);
		pp.backend.formHelpers.initDateTimePicker();
		pp.backend.formHelpers.convertFormHintsToPopovers();
		const $mirrorableInputs = $("input[data-mirror-to-selector]");
		pp.backend.formHelpers.initMirrorInputs($mirrorableInputs);

		// @ts-expect-error
		pp.backend.formHelpers.showOrRemoveRtfInfosAddButtonFor(
			$(".Form__nested-fields-set"),
		);

		$(".Form__fake-label").on("click", function (e) {
			const $closestInput = $(this)
				.parents(".form-group")
				.find("input:visible, textarea:visible")
				.first();
			$closestInput.focus();
		});

		$(".j-toggle-all-panels-in-module").on("click", function (e) {
			$(this).parents(".Module").find('[data-toggle="collapse"]').click();
		});

		// Hack to sort the Actor tables by function via clicking the tablesorter header el
		const $functionSorters = $(".j-function-th");
		$.each($functionSorters, (idx, el) => {
			const $functionSorter = $(el);
			if (!$functionSorter.hasClass("headerSortDown")) {
				$functionSorter.trigger("click");
			}
		});

		pp.backend.initBackendFilters();
		pp.stickyButtons.setOnlineActorsList();
	},

	extractFormButtons() {
		// pp.log("into extractFormButtons");
		const $buttonsContainer = $(".j-page-head-buttons");
		if (!$buttonsContainer.length) {
			return;
		}

		const $clonedButtonContainer =
			$(".HUD__right-hand-content").length &&
			!$buttonsContainer.children(".j-dont-elevate-to-HUD").length
				? $(".HUD__right-hand-content")
				: $(".PageHead__right-floating-elem");

		// Hide the whole nodule header if there is no other content
		if (
			!$buttonsContainer.siblings().length &&
			$buttonsContainer.closest(".Module__header").length
		) {
			$buttonsContainer.closest(".Module__header").addClass("hidden");
		} else {
			$buttonsContainer.addClass("hidden");
		}

		$buttonsContainer.children().each(function () {
			const $clonedButton = $(this).clone();
			const formId = $clonedButton.attr("form");
			const buttonText = $clonedButton.text() || $clonedButton.val();

			// pp.log("cloned", $clonedButton);
			// Re-add `href` from `data-stored-href` to the button again if present,
			// so that `pp.global.emulateMethodLinksFormBehavior.prepareLinks` will see the button
			// (via `untreatedLinkSelector`)
			if ($clonedButton.attr("data-stored-href") !== undefined) {
				// @ts-expect-error
				$clonedButton.attr("href", $clonedButton.attr("data-stored-href"));
			}
			// Avoid attaching the same button (here: a button with the same `form` attribute) twice
			if (
				$clonedButtonContainer.find(`[form='${formId}']`).length ||
				$clonedButtonContainer.find(`:contains('${buttonText}')`).length
			) {
				return;
			}

			$clonedButtonContainer.append($clonedButton);

			// NB this would normally be handled in `pp.global.handlePageChangeEvent`,
			// but the button is only inserted after that function has has been called (both via 'page:change'),
			// so the popover needs to be initialized separately
			if ($clonedButton.attr("data-content") !== undefined) {
				// @ts-expect-error
				$clonedButton.popover();
			}

			// For extra option buttons in a dropdown menu (for buttons that have the class 'btn-group')
			$clonedButton.find("ul.dropdown-menu a").on("click", function () {
				const $clickedDropdownButton = $(this);
				// @ts-expect-error
				$($clickedDropdownButton.data("forInput")).val(true);
				$clonedButton.find('button[type="submit"]').trigger("click");
			});
		});
	},

	handleCmsEvents(data, channel) {
		if (!data.event) {
			return;
		}
		// pp.log("handleCmsEvents incoming", data);

		switch (data.event) {
			case "created_calculation":
				// pp.log("cms created_calculation incoming", data);
				$("#add-property-modal").find("select").append(data.payload);
				break;

			case "destroyed_drawflow_item":
				pp.log("cms destroyed_drawflow_item incoming", data);
				if (
					pp.DrawflowWrapper.editor &&
					["Property", "ActorProperty", "Measure", "ArticleMeasure"].includes(
						data.item_class,
					)
				) {
					pp.DrawflowWrapper.editor.markNodesAsDeletedOnRemove = false;
					const payloadItem = Object.values(data.payload)[0];
					const nodeId = (payloadItem.parent_node || payloadItem).id;
					if (!pp.DrawflowWrapper.editor.getNodeFromId(nodeId)) {
						pp.DrawflowWrapper.editor.markNodesAsDeletedOnRemove = true;
						return; // Must already have been deleted
					}
					pp.DrawflowWrapper.editor.removeNodeId(nodeId);
					pp.DrawflowWrapper.editor.markNodesAsDeletedOnRemove = true;
					return;
				}
				// Else
				console.error("Can't process incoming cms event data", data);
				break;

			case "new_cloning_job":
				if (!$(".j-game-clone-worker-items-container").length) {
					return;
				}
				if ($(`#j-game-clone-worker-item-${data.job_id}`).length) {
					// pp.log("already present");
					return;
				}
				const gameCloneWorkerItem =
					"<game-clone-worker-item class='page-vue-instance' :srv-job-id='\"" +
					data.job_id +
					"\"' :srv-clone-params='" +
					data.clone_params +
					"' :srv-game-token='\"" +
					data.game_token +
					"\"' :srv-user-id=" +
					data.user_id +
					" :srv-enqueued-at='" +
					data.enqueued_at +
					"' :srv-faye-subscription=" +
					data.faye_subscription +
					"></game-clone-worker-item>";
				$(".j-game-clone-worker-items-container").append(gameCloneWorkerItem);
				pp.vue.mountElementsInContainer(
					$(".j-game-clone-worker-items-container"),
				);
				break;

			case "game_start_and_end_date_change":
				if (pp.phaseManager.gameIdForCmsEvents == data.game_id) {
					eval(data.payload);
				}
				break;

			case "updated_drawflow_item":
				pp.log("cms updated_drawflow_item incoming", data);
				pp.DrawflowWrapper.importNodesFromRails(data.payload);
				break;

			case "updated_phase_durations":
				if (pp.phaseManager.gameIdForCmsEvents == data.game_id) {
					pp.phaseManager.phaseDurations = data.payload;
				}
				break;

			case "soft_validator_start":
				if (!$(`.${data.uid}`).length) {
					return; // Not the right target
				}
				const $logoContainer = $(".HUD__logo");
				$logoContainer.find(".Avatar__image").addClass("hidden");
				$logoContainer.find(".lds-ring").removeClass("hidden");
				break;

			case "custom_error_added":
				const $logoContainer2 = $(".HUD__logo");
				$logoContainer2.find(".Avatar__image").removeClass("hidden");
				$logoContainer2.find(".lds-ring").addClass("hidden");
				if (!data.payload.length) {
					$(`.${data.uid}`).remove();
				} else {
					$(`.${data.uid}`).removeClass("hidden");
					$(`.${data.uid} .Module__content`).html(data.payload);
				}
				break;

			default:
				console.error("CMS event not implemented:", data.event);
		}
	},

	fetchNewKnowledgeBaseWizardSelect() {
		const $select = $("#kbm_route_preselect");
		$select.html("");
		const modulesOnPageNames = $(".Module[data-kb-module-name]")
			.get()
			.map((moduleEl) => {
				return $(moduleEl).attr("data-kb-module-name");
			});
		$.ajax({
			url: "/kb_modules/wizard_select_content",
			type: "GET",
			dataType: "json",
			data: {
				current_path: window.location.pathname,
				module_names: modulesOnPageNames,
			},
		})
			// @ts-expect-error
			.success((data) => {
				data.forEach((routeOrModule) => {
					$select.append(
						`<option value='${routeOrModule}'>${routeOrModule}<option>`,
					);
					$select.children().last().remove(); // select2 always adds and empty option by itself for some reason
				});
				// Submit immediately if only one option exists
				if (data.length == 1) {
					// @ts-expect-error
					$select[0].form.submit();
				}
			})
			.fail(() => {
				pp.log("BACKEND fetchNewKnowledgeBaseWizardSelect failed");
			});
	},

	modChatUnreadCounts: {
		unreadMsgs: 0,

		init() {
			this.observeChange("unreadMsgs", this.updateVisually);
			pp.vue.bus.$on("moderator_chat_tab-OPEN", () => {
				pp.backend.modChatUnreadCounts.unreadMsgs = 0;
			});
			pp.vue.bus.$on("moderator_chat-CREATE", () => {
				pp.backend.modChatUnreadCounts.unreadMsgs++; // Assume that a newly created mod chat has exactly one message
			});

			pp.vue.bus.$on("moderator_chat_message-CREATE", () => {
				if ($("#mod-chat.tab-pane.active.in").length) {
					return; // Don't increment if chat is being displayed
				}
				pp.backend.modChatUnreadCounts.unreadMsgs++;
			});

			$("#comms-modal").on("shown.bs.modal", () => {
				if ($("#mod-chat.tab-pane.active.in").length) {
					pp.backend.modChatUnreadCounts.unreadMsgs = 0; // Set to 0 and trigger update via the observer
				} else {
					pp.backend.modChatUnreadCounts.updateVisually(); // Trigger visual update manually
				}
			});
		},

		updateVisually() {
			const $elements = $(".Sticky-button__floating-overlay--mod-chat-msgs");
			const $dotEl = $(".j-mod-chat-unread-count-dot");

			$elements[
				pp.backend.modChatUnreadCounts.unreadMsgs == 0
					? "addClass"
					: "removeClass"
			]("hidden");
			$dotEl[
				pp.backend.modChatUnreadCounts.unreadMsgs > 0
					? "addClass"
					: "removeClass"
			]("unread").removeClass((index, classNames) =>
				// @ts-expect-error
				classNames.match(/unread-?\d*/g).join(" "),
			);

			if (pp.backend.modChatUnreadCounts.unreadMsgs < 1) {
				return;
			}
			$elements.text(pp.backend.modChatUnreadCounts.unreadMsgs);
			// CSS doesn't allow >10
			$dotEl.addClass(
				`unread unread-${pp.backend.modChatUnreadCounts.unreadMsgs > 9 ? 10 : pp.backend.modChatUnreadCounts.unreadMsgs}`,
			);
		},
	},

	modActorModals: {
		showFor: (actorId, isGroup) => {
			const $actorModal = $(`#mod-actor-modal-${actorId}`);

			if ($actorModal.length) {
				$("div.modal.in").modal("hide");
				$actorModal.modal("show");
				window.location.hash = `#${isGroup ? "group" : "role"}-${actorId}`;
			} else {
				pp.backend.modActorModals.cloneModalFor(actorId, isGroup);
			}
		},

		cloneModalFor: (actorId, isGroup) => {
			const $template = $(`#mod-${isGroup ? "group" : "role"}-modal-template`);
			const $clone = $template.clone();
			$clone
				.attr("id", `mod-actor-modal-${actorId}`)
				.insertAfter("div.content");
			pp.backend.modActorModals.showFor(actorId, isGroup);
			pp.backend.modActorModals.populateModalBlock(
				$clone,
				actorId,
				"avatar_and_name",
			);
			pp.backend.modActorModals.populateModalBlock(
				$clone,
				actorId,
				"key_facts",
			);

			$clone.on("hide.bs.modal", () => {
				window.setTimeout(() => {
					if (!$(".modal.in").length) {
						// @ts-expect-error
						history.pushState(null, null, " ");
					}
				}, 500);
			});
			// Convert the tab pane ids to unique strings by appending "-actor-${actorId}"
			$clone.find("ul.Nav a").each((index, elem) => {
				const $elem = $(elem);
				let newHref;
				const origBlockName = $elem.attr("href");
				if (origBlockName == "#articles_link") {
					newHref = `/negotiations?filter_actor_id=${actorId}`;
					$elem.on("click", () => {
						// Close modal
						$(`#mod-actor-modal-${actorId}`).modal("hide");
					});
				} else {
					newHref = `${origBlockName}-actor-${actorId}`;
					// @ts-expect-error
					const $targetPane = $clone.find(origBlockName);
					$targetPane.attr("id", newHref.substring(1)); // Cut off the '#' from the `href`
					$elem.one("show.bs.tab", (event) => {
						pp.backend.modActorModals.populateModalBlock(
							$clone,
							actorId,
							// @ts-expect-error
							origBlockName.substring(1),
						); // Cut off the '#' from the `href`
					});
				}
				$elem.attr("href", newHref);
				if (index == 0) {
					// Load first tab
					$elem.trigger("click");
				}
			});
		},

		populateModalBlock: ($modal, actorId, blockName) => {
			// @ts-expect-error
			$.ajax({
				url: `/actors/${actorId}.js`,
				type: "GET",
				data: { block_name: blockName },
				dataType: "html",
				tryCount: 0,
				retryLimit: 3,
				timeout: 5000,
				success: function (data) {
					const $block = $modal.find(`.j-${blockName}-block`);
					$block.html(data); // For search replace: j-key_facts-block
					$block.find("time[data-time-ago]").timeago();
					pp.vue.mountElementsInContainer($block);
					$block.find("a.popover-action").popover();
					pp.global.initSelect2For($block.find("select"));
					pp.backend.initBackendFilters($block);
				},
				error: function (xhr, textStatus, errorThrown) {
					if (textStatus == "timeout") {
						this.tryCount++;
						if (this.tryCount <= this.retryLimit) {
							$.ajax(this); // Try again
						} else {
							// TODO error msg
						}
					}
				},
			});
		},
	},

	modModalNavigation: {
		setupListeners: () => {
			$(window).on(
				"hashchange",
				pp.backend.modModalNavigation.handleHashChange,
			);
			pp.backend.modModalNavigation.handleHashChange(); // Trigger once now
		},

		// GOTCHA - If the Game has ended a role modal in the hash will not show again after refresh due to the game state function handleModalVisibilityChange
		handleHashChange: (event) => {
			// pp.log("hash change", window.location.hash, window.location.hash === "", window.location.hash === undefined)
			if (window.location.hash === "") {
				if ($(".modal.in.j-modal-navigable").length) {
					$(".modal.in").modal("hide");
				}
				return;
			}
			const modalType = window.location.hash.split("-")[0];
			// @ts-expect-error
			if (modalType.startsWith("#group") || modalType.startsWith("#role")) {
				const actorId = window.location.hash.split("-")[1];
				pp.backend.modActorModals.showFor(
					actorId,
					window.location.hash.startsWith("#group-"),
				);
			}
		},
	},

	// --- MOD AREA UPDATE --------------------------
	modTasks: {
		primedForTaskPanelId: null,

		init: (containerSelector) => {
			$(`${containerSelector} .TaskPanel`).each((index, elem) => {
				pp.backend.modTasks.handlePanel(elem);

				// The mod feedback textarea - can't put this into `handlePanel` because adding a listener will trigger the observer and thus start
				// an endless cascade
				$(elem)
					.find(".panel-collapse.collapse")
					.one("shown.bs.collapse", () => {
						// @ts-expect-error
						$(elem).find("textarea").autosize();
					});

				pp.backend.modTasks.panelObserver.observe(elem, { attributes: true });

				// Open panel if the JS has been primed to do so
				if (pp.backend.modTasks.primedForTaskPanelId) {
					pp.log(
						"MOD TASKS primedForTaskPanelId present:",
						pp.backend.modTasks.primedForTaskPanelId,
					);
					pp.backend.modTasks.triggerTaskPanelLink(
						$(containerSelector),
						pp.backend.modTasks.primedForTaskPanelId,
					);
					pp.backend.modTasks.primedForTaskPanelId = null; // Reset after the work is done
				}

				// NB this only works if the `actor-list-items` Vue element has already been mounted, which happens via `mountElementsInContainer`
				// in `_modal_overlays`, but still takes a while
				setTimeout(() => {
					$(elem)
						.find(".TaskPanel__body__actors-tasks-states a.Avatar__image")
						.on("click", (event) => {
							const targetTaskId = $(event.target)
								.closest(".TaskPanel")
								.attr("data-task-id");
							pp.log("MOD TASKS priming Task id", targetTaskId);
							// @ts-expect-error
							pp.backend.modTasks.primedForTaskPanelId = targetTaskId;
						});
				}, 100);
			});
		},

		panelObserver: new MutationObserver((mutations) => {
			mutations.forEach(({ type, target }) => {
				if (type == "attributes") {
					pp.backend.modTasks.handlePanel(target);
				}
			});
		}),

		handlePanel: (panel) => {
			const $taskPanel = $(panel);
			// pp.log("at panel", $taskPanel, $taskPanel.data());

			const taskId = $taskPanel.data("taskId");

			const actorsWithTask = $taskPanel.data("actorsWithTask");
			const actorsWithGradedTask = $taskPanel.data("actorsWithGradedTask");
			const actorsWithCompletedTask = $taskPanel.data(
				"actorsWithCompletedTask",
			);
			let actorsWithGradedOrCompletedTask;

			let actorsWithWhollyCompletedTask;

			if (actorsWithGradedTask !== undefined) {
				actorsWithGradedOrCompletedTask = [
					...new Set(actorsWithCompletedTask.concat(actorsWithGradedTask)),
				]; // `Set` filters out dupes

				actorsWithWhollyCompletedTask = actorsWithGradedTask;

				// "submitted" here means "pending grading"
				const actorsWithSubmittedTask = actorsWithCompletedTask.filter(
					(actorId) => !actorsWithGradedTask.includes(actorId),
				);
				pp.vue.bus.$emit("actor-list-items-UPDATE", {
					identifier: `mod-task-panel-body--ungraded-${taskId}`,
					actorIds: actorsWithSubmittedTask,
				});
				$taskPanel
					.find(".TaskPanel__body__actors-tasks-states--ungraded")
					.text(actorsWithSubmittedTask.length);

				// If a Task has no actorsWithTask, this calculation will be `0 / 0` which is NaN, so default to `0`
				const gradedTasksFloat =
					(actorsWithCompletedTask.length - actorsWithGradedTask.length) /
						actorsWithTask.length || 0;
				$taskPanel
					.find(".j-task-numericals--gradable")
					.text(`${Math.round(gradedTasksFloat * 100)}%`);

				// This bar also starts at the left border of the `.PropertyValueBar__value-bar` and needs to be offset by the bar for "submitted" Tasks
				$taskPanel
					.find(".TaskColor--task-submitted-for-grading")
					.css(
						"width",
						`${((actorsWithWhollyCompletedTask.length + actorsWithSubmittedTask.length) / actorsWithTask.length) * 100}%`,
					);
			} else {
				actorsWithGradedOrCompletedTask = actorsWithCompletedTask;
				actorsWithWhollyCompletedTask = actorsWithCompletedTask;
			}
			// For gradable Tasks: ActorTasks that are graded (even if they are not marked "completed" by the Actor),
			// for tick-Tasks: ActorsTasks that have been marked "completed"
			pp.vue.bus.$emit("actor-list-items-UPDATE", {
				identifier: `mod-task-panel-body--graded-or-completed-${taskId}`,
				actorIds: actorsWithWhollyCompletedTask,
			});
			$taskPanel
				.find(".TaskPanel__body__actors-tasks-states--graded-or-completed")
				.text(actorsWithWhollyCompletedTask.length);

			// Tasks that have neither been completed nor graded (if they are gradable in the first place)
			const actorsWithUnCompletedOrUngradedTask = actorsWithTask.filter(
				(actorId) => !actorsWithGradedOrCompletedTask.includes(actorId),
			);
			pp.vue.bus.$emit("actor-list-items-UPDATE", {
				identifier: `mod-task-panel-body-uncompleted-${taskId}`,
				actorIds: actorsWithUnCompletedOrUngradedTask,
			});
			$taskPanel
				.find(".TaskPanel__body__actors-tasks-states--uncompleted")
				.text(actorsWithUnCompletedOrUngradedTask.length);

			$taskPanel
				.find(".TaskInfoItems__numericals--actors-size")
				.text(actorsWithTask.length);
			$taskPanel
				.find(".TaskColor--task-graded-or-completed")
				.css(
					"width",
					`${(actorsWithWhollyCompletedTask.length / actorsWithTask.length) * 100}%`,
				);

			$taskPanel
				.find(".j-task-numericals--graded-or-completed")
				.text(
					`${Math.round((actorsWithWhollyCompletedTask.length / actorsWithTask.length) * 100)}%`,
				);

			// For a TaskPanel that's showing all Actors' statuses
			if (!$taskPanel.closest(".SingleActorTasks").length) {
				$taskPanel
					.find(".Task__completeness-toggle")
					[
						actorsWithGradedOrCompletedTask.length == actorsWithTask.length
							? "addClass"
							: "removeClass"
					]("Task__completeness-toggle--completed");
			}
			// For a TaskPanel for an individual Actor
			else {
				const actorId = $taskPanel.closest(".SingleActorTasks").data("actorId");
				// const markCompleted = actorsWithCompletedTask.includes(actorId) || (actorsWithSubmittedTask !== undefined && actorsWithSubmittedTask.includes(actorId));
				$taskPanel
					.find(".Task__completeness-toggle")
					[
						actorsWithGradedOrCompletedTask.includes(actorId)
							? "addClass"
							: "removeClass"
					]("Task__completeness-toggle--completed");

				if (actorsWithGradedTask !== undefined) {
					// Allow gradig of Tasks also when the Task belongs to a previous Phase (the `phaseNumber will be `-1` if the Game has ended)
					const allowGrading =
						(actorsWithCompletedTask.includes(actorId) &&
							!actorsWithGradedTask.includes(actorId)) ||
						// @ts-expect-error
						$taskPanel.data("phaseNumber") < pp.gameState.phaseNumber;
					$taskPanel
						.find(".TaskPanel__answer-text")
						[allowGrading ? "addClass" : "removeClass"](
							"TaskPanel__answer-text--grading-allowed",
						);
					if (actorsWithGradedTask.includes(actorId)) {
						$taskPanel
							.find(".TaskPanel__answer-text")
							.addClass("TaskPanel__answer-text--graded");
						$taskPanel.find(".j-star").removeClass("j-star");
						// Flag as disabled also for mods to get the green checkmark in case this Task is gradable
						$taskPanel
							.find(".Task__completeness-toggle")
							.prop("disabled", actorsWithGradedTask.includes(actorId));
					}
				} else {
					$taskPanel
						.find(".Task__completeness-toggle")
						.prop("disabled", actorsWithCompletedTask.includes(actorId));
				}
			}
		},

		setTaskStatusForActor: (taskId, actorId, state) => {
			pp.backend.modTasks.updateTaskPanelData(taskId, actorId, state);
			pp.backend.modTasks.setTaskCompletenessIndicatorsState(
				taskId,
				actorId,
				state,
			);
			pp.backend.modTasks.updateActorIndexItemData(taskId, actorId, state);
		},

		setTaskCompletenessIndicatorsState: (taskId, actorId, state) => {
			$(
				`.TasksBreakdown__task[data-task-id='${taskId}'][data-actor-id='${actorId}']`,
			).each((idx, el) => {
				const $taskCompletionIndicator = $(el);

				// Use jQuery's filter function to simplify removal of specific class names
				$taskCompletionIndicator.removeClass(function (index, className) {
					return (className.match(/(^|\s)TaskColor--\S+/g) || []).join(" ");
				});

				const isGradable = $taskCompletionIndicator.hasClass(
					"TaskBreakdown__task--is-gradable",
				);
				const newClass = pp.backend.modTasks.jsActorTaskStateToCssClass(
					state,
					isGradable,
				);

				$taskCompletionIndicator.addClass(newClass);
			});
		},

		jsActorTaskStateToCssClass: (state, isGradable) => {
			const classMapping = {
				graded: "task-graded-or-completed",
				completed: isGradable
					? "task-submitted-for-grading"
					: "task-graded-or-completed",
				uncompleted: "task-uncompleted",
			};
			return `TaskColor--${classMapping[state]}`;
		},

		updateTaskPanelData: (taskId, actorId, state) => {
			$(`.TaskPanel[data-task-id='${taskId}']`).each((index, elem) => {
				const $taskPanel = $(elem);

				// pp.log("updateTaskPanelData", $taskPanel, actorId, state)
				const actorsWithGradedTask = $taskPanel.data("actorsWithGradedTask");
				const actorsWithCompletedTask = $taskPanel.data(
					"actorsWithCompletedTask",
				);

				if (state == "graded" && actorsWithGradedTask !== undefined) {
					actorsWithGradedTask.push(actorId);
					$taskPanel.attr("data-actors-with-graded-task", actorsWithGradedTask);
				} else if (state == "completed") {
					actorsWithCompletedTask.push(actorId);
					$taskPanel.attr(
						"data-actors-with-completed-task",
						actorsWithCompletedTask,
					);
				} else {
					// Expect 'uncompleted'
					const index = actorsWithCompletedTask.indexOf(actorId);
					actorsWithCompletedTask.splice(index, 1);
					$taskPanel.attr(
						"data-actors-with-completed-task",
						actorsWithCompletedTask,
					);
				}
			});
		},

		actorIndexItemObserver: new MutationObserver((mutations) => {
			mutations.forEach(({ type, target }) => {
				if (type == "attributes") {
					pp.backend.modTasks.handleActorIndexItem(target);
				}
			});
		}),

		handleActorIndexItem: (cell) => {
			const $cell = $(cell);
			// pp.log("handleActorIndexItem", $cell, $cell.data());

			const completedTaskIds = $cell.data("completedTaskIds");
			const ungradedTaskIds = $cell
				.data("gradableTaskIds")
				.filter((taskId) => !$cell.data("gradedTaskIds").includes(taskId));

			const whollyCompletedTaskIds = completedTaskIds.filter(
				(taskId) => !ungradedTaskIds.includes(taskId),
			);
			$cell.find(".j-completed-tasks").text(whollyCompletedTaskIds.length);
			$cell.find(".j-all-tasks").text($cell.data("taskIds").length); // This should never change dynamically
		},

		updateActorIndexItemData: (taskId, actorId, state) => {
			$(`.ActorIndexItem__tasks-cell[data-actor-id='${actorId}']`).each(
				(index, elem) => {
					const $cell = $(elem);
					const completedTaskIds = $cell.data("completedTaskIds");
					const gradedTaskIds = $cell.data("gradedTaskIds");
					if (state == "graded") {
						gradedTaskIds.push(taskId);
					} else if ("completed" == state) {
						completedTaskIds.push(taskId);
					} else {
						const index = completedTaskIds.indexOf(taskId);
						completedTaskIds.splice(index, 1);
					}
					$cell.attr("data-completed-task-ids", completedTaskIds);
					$cell.attr("data-graded-task-ids", gradedTaskIds);
				},
			);
		},

		// NB `taskId` might be `undefined`
		triggerTaskPanelLink: ($container, taskId) => {
			const $taskPanel = $container.find(
				`.TaskPanel[data-task-id='${taskId}']`,
			);
			pp.log("MOD TASKS triggerTaskPanelLink", $container, $taskPanel);
			$taskPanel.find("a[data-toggle='collapse']").trigger("click");
			setTimeout(() => {
				// Wait until panel is open
				pp.viewHelpers.scrollToElement($taskPanel);
			}, 500);
		},
	},

	modNegotiationsIndex: {
		init: (containerSelector) => {
			const $container = $(containerSelector);
			$container.children(".panel").each((index, elem) => {
				pp.backend.modNegotiationsIndex.handlePanel(
					$(elem).find(".Nav.Nav--tabs"),
				); // Trigger once now
				pp.backend.modNegotiationsIndex.panelObserver.observe(
					// @ts-expect-error
					$(elem).find(".Nav.Nav--tabs")[0],
					{ childList: true },
				);
			});
		},

		panelObserver: new MutationObserver((mutations) => {
			mutations.forEach(({ type, target }) => {
				if (type == "childList") {
					pp.backend.modNegotiationsIndex.handlePanel(target);
				}
			});
		}),

		handlePanel: (target) => {
			const $draftsNavigation = $(target);
			const $articlePanelHeading = $draftsNavigation
				.closest(".panel")
				.children(".panel-heading");
			$articlePanelHeading
				.find(".j-passed-draft-presence")
				[
					$draftsNavigation.find(".Draft--nav--state-passed").length
						? "removeClass"
						: "addClass"
				]("hidden");
			$articlePanelHeading
				.find(".j-submitted-drafts-size .RecordIndex__item__stacked-number")
				.text(
					$draftsNavigation.children(":not(.Draft--nav--state-unsubmitted)")
						.length,
				);
		},
	},
};

$("body").ready(() => {
	// init backend stuff
	pp.backend.initTableSorter();

	// Make sure to only append listener once
	// attach this to the pp object, pp.backend will be re-initialized
	// @ts-expect-error
	if (pp.backendPageChangeListener === undefined) {
		// @ts-expect-error
		pp.backendPageChangeListener = $(document).on(
			"page:change",
			pp.backend.handlePageChangeEvent,
		);
	}
});
